import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

const RemoveJobFromEmailNotificationModal = ({ open, onClose, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            title="Remove job from email?"
            confirmButtonText="Confirm"
            open={open}
            onCancel={onClose}
            onClose={onClose}
            onConfirm={onConfirm}
            content={
                <>
                    <Typography>Do you want to remove the job from the email?</Typography>
                </>
            }
        />
    );
};

export default RemoveJobFromEmailNotificationModal;
